export interface DocPage {
  title: string
  slug: string
  file: string // MDX file path
}

export interface DocSection {
  title: string
  pages: DocPage[]
}

export const docsStructure: DocSection[] = [
  {
    title: 'Getting Started',
    pages: [
      { title: 'Welcome', slug: '', file: 'intro' },
      { title: 'Quick Start', slug: 'quickstart', file: 'getting-started/quickstart' },
      { title: 'Prerequisites', slug: 'prerequisites', file: 'getting-started/prerequisites' },
      { title: 'First Validation', slug: 'first-validation', file: 'getting-started/first-validation' },
    ],
  },
  {
    title: 'Configuration',
    pages: [
      { title: 'Network Setup', slug: 'repository-setup', file: 'configuration/repository-setup' },
      { title: 'Config Formats', slug: 'config-formats', file: 'configuration/config-formats' },
      { title: 'Topology Format', slug: 'topology-format', file: 'configuration/topology-format' },
      { title: 'Invariants', slug: 'invariants', file: 'configuration/invariants' },
    ],
  },
  {
    title: 'Validation',
    pages: [
      { title: 'Analysis Mode', slug: 'analysis-mode', file: 'validation/analysis-mode' },
      { title: 'Validation Reports', slug: 'validation-reports', file: 'validation/validation-reports' },
    ],
  },
  {
    title: 'Integrations',
    pages: [
      { title: 'GitHub App', slug: 'github-app', file: 'integrations/github-app' },
      { title: 'GitHub Actions', slug: 'github-actions', file: 'integrations/github-actions' },
      { title: 'GitHub Webhook', slug: 'github-webhook', file: 'integrations/github-webhook' },
      { title: 'API Access', slug: 'api-access', file: 'integrations/api-access' },
    ],
  },
  {
    title: 'Guides',
    pages: [
      { title: 'Multi-Vendor Networks', slug: 'multi-vendor-networks', file: 'guides/multi-vendor-networks' },
      { title: 'Security & Compliance', slug: 'security-compliance', file: 'guides/security-compliance' },
      { title: 'Troubleshooting', slug: 'troubleshooting', file: 'guides/troubleshooting' },
    ],
  },
  {
    title: 'Reference',
    pages: [
      { title: 'API Reference', slug: 'api-reference', file: 'reference/api-reference' },
      { title: 'CLI Reference', slug: 'cli-reference', file: 'reference/cli-reference' },
      { title: 'Invariant Types', slug: 'invariant-types', file: 'reference/invariant-types' },
      { title: 'Supported Platforms', slug: 'supported-platforms', file: 'reference/supported-platforms' },
      { title: 'Limits', slug: 'limits', file: 'reference/limits' },
    ],
  },
]

// Flatten all pages for easy lookup
export const allDocsPages = docsStructure.flatMap((section) => section.pages)

// Get page by slug
export function getPageBySlug(slug: string): DocPage | undefined {
  return allDocsPages.find((page) => page.slug === slug)
}

// Get next and previous pages for navigation
export function getAdjacentPages(currentSlug: string): {
  prev: DocPage | null
  next: DocPage | null
} {
  const currentIndex = allDocsPages.findIndex((page) => page.slug === currentSlug)

  return {
    prev: currentIndex > 0 ? allDocsPages[currentIndex - 1] : null,
    next: currentIndex < allDocsPages.length - 1 ? allDocsPages[currentIndex + 1] : null,
  }
}
